import React, { useMemo } from 'react';
import { useEffectiveMe } from '@/lib/effectiveMe';
import SettingsLayout from '@/components/settings/SettingsLayout';
import SettingsHubCard from '@/components/settings/SettingsHubCard';
import { SETTINGS_SECTIONS, visibleSettingsItems } from '@/data/settingsCatalog';

export default function SettingsHome() {
  const me = useEffectiveMe();
  const items = useMemo(() => visibleSettingsItems(me), [me]);
  const description = me?.is_global
    ? 'Configura e gestisci la piattaforma in modo semplice e centralizzato.'
    : 'Configura il perimetro e le regole operative del tuo tenant.';

  return (
    <SettingsLayout
      eyebrow="Impostazioni"
      title="Impostazioni"
      description={description}
      testId="settings-home-page"
    >
      <div className="space-y-8" data-testid="settings-home-catalog">
        {SETTINGS_SECTIONS.map((section) => {
          const sectionItems = items.filter((item) => item.section === section.id);
          if (!sectionItems.length) return null;
          return (
            <section
              key={section.id}
              aria-labelledby={`settings-section-${section.id}`}
              data-testid={`settings-section-${section.id}`}
            >
              <div className="mb-3 flex items-center gap-3">
                <h2
                  id={`settings-section-${section.id}`}
                  className="font-display text-lg font-semibold text-brand-navy"
                >
                  {section.title}
                </h2>
                <span className="h-px flex-1 bg-stone-200" aria-hidden="true" />
              </div>
              <div className="grid gap-3 lg:grid-cols-2">
                {sectionItems.map((item) => <SettingsHubCard key={item.id} item={item} />)}
              </div>
            </section>
          );
        })}
      </div>
    </SettingsLayout>
  );
}